module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.user) ? _c('div', {
    staticClass: "row end-xs"
  }, [_c('div', {
    staticClass: "row end-xs"
  }, [_c('button', {
    staticClass: "login-button",
    on: {
      "click": _vm.login
    }
  }, [_c('i', {
    staticClass: "icon ion-log-in"
  }), _vm._v("\n      Login\n    ")])])]) : _c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "user-bar row middle-xs"
  }, [_c('div', {
    staticClass: "username-container col-xs-6 middle-xs"
  }, [(!_vm.isUsernameEditable) ? _c('span', {
    on: {
      "click": _vm.handleUserNameEditClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n        "), _c('i', {
    staticClass: "icon ion-edit"
  })]) : _c('input', {
    ref: "userNameInput",
    staticClass: "user-name-input",
    domProps: {
      "value": _vm.editableUsername
    },
    on: {
      "input": _vm.handleUserNameInput,
      "blur": _vm.handleUserNameBlur,
      "keypress": _vm.handleUserNameKeyPress
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 middle-xs"
  }, [_c('button', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon ion-log-out"
  }), _vm._v("\n        Logout\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b1d00c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserBar/index.vue
// module id = 715
// module chunks = 1